import React from 'react';

import { Select, SelectProps } from '@mantine/core';

import classes from './kiloSelect.module.css';

type KiloSelectVariant = 'default' | 'short';

type KiloSelectProps = SelectProps & {
  rootVariantType?: KiloSelectVariant;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const KiloSelect = ({ rootVariantType = 'default', data, ...rest }: KiloSelectProps): JSX.Element => {
  const variantClassMap: Record<KiloSelectVariant, string> = {
    default: '',
    short: classes.short,
  };
  return (
    <Select
      classNames={{
        root: variantClassMap[rootVariantType],
      }}
      {...rest}
      data={data}
    />
  );
};

export default KiloSelect;
